type CacheEntry<T> = {
  expiresAt: number
  promise: Promise<T>
}

// Ключи не вытесняются: подходит только для конечного набора ключей
export const memoizeAsync = <T, K = void>(load: (key: K) => Promise<T>, ttlMs: number) => {
  const entries = new Map<K, CacheEntry<T>>()

  return (key: K): Promise<T> => {
    const cached = entries.get(key)

    if (cached && cached.expiresAt > Date.now()) {
      return cached.promise
    }

    const promise = load(key)

    entries.set(key, { expiresAt: Date.now() + ttlMs, promise })
    promise.catch(() => {
      if (entries.get(key)?.promise === promise) {
        entries.delete(key)
      }
    })

    return promise
  }
}
